<template>
  <modal
    :name="modalName"
    height="auto"
    width="980"
    :scrollable="true"
    :clickToClose="false"
  >
    <CloseModal :close="closeModal" />
    <Loading :isActive="loading" />
    <div class="modalbox grupo-grade-modalbox">
      <div class="modalbox-content">
        <h4 class="modal-title">
          {{ item.id ? "Editar Grupo de Grade" : "Novo Grupo de Grade" }}
        </h4>

        <CTabs variant="tabs" class="nav-tabs-boxed">
          <CTab title="Informações">
            <StepInformacoes :form="item" />
          </CTab>
          <CTab title="Classificação">
            <StepRegras :form="item" :colunasDisponiveis="colunasDisponiveis" />
          </CTab>
          <CTab title="Filtros">
            <StepCampos :form="item" :colunasDisponiveis="colunasDisponiveis" />
          </CTab>
          <CTab title="Pré-visualização">
            <StepPreview :form="item" :colunasDisponiveis="colunasDisponiveis" />
          </CTab>
        </CTabs>

        <CAlert color="danger" v-if="erros.length" class="mt-3 erros-alert">
          <strong>Não foi possível salvar:</strong>
          <ul class="m-0 pl-3 mt-2">
            <li v-for="(e, i) in erros" :key="i">{{ e }}</li>
          </ul>
        </CAlert>
      </div>
    </div>
    <div class="modal-footer-bar">
      <CButton variant="outline" color="secondary" @click="closeModal">
        Cancelar
      </CButton>
      <CButton color="primary" @click="handleSubmit" :disabled="loading">
        {{ item.id ? "Salvar alterações" : "Criar grupo" }}
      </CButton>
    </div>
  </modal>
</template>

<script>
import { post, put } from "@/helpers/apiRequest";
import CloseModal from "@/components/CloseModal.vue";
import Loading from "@/components/Loading.vue";
import StepInformacoes from "./sections/StepInformacoes.vue";
import StepRegras from "./sections/StepRegras.vue";
import StepCampos from "./sections/StepCampos.vue";
import StepPreview from "./sections/StepPreview.vue";

export default {
  name: "ModalGrupoGrade",
  components: {
    CloseModal,
    Loading,
    StepInformacoes,
    StepRegras,
    StepCampos,
    StepPreview,
  },
  props: {
    item: { type: Object, required: true },
    colunasDisponiveis: { type: Array, default: () => [] },
    close: { type: Function, required: true },
  },
  data() {
    return {
      modalName: "ModalGrupoGrade",
      loading: false,
      erros: [],
    };
  },
  methods: {
    closeModal() {
      this.$modal.hide(this.modalName);
    },
    validar() {
      const erros = [];

      if (!this.item.nome || !this.item.nome.trim()) {
        erros.push("Nome é obrigatório.");
      }
      if (!this.item.regras || !this.item.regras.length) {
        erros.push("Adicione pelo menos 1 regra de vínculo.");
      }
      if (!this.item.campos || !this.item.campos.length) {
        erros.push("Adicione pelo menos 1 campo de variação.");
      }

      (this.item.regras || []).forEach((r, i) => {
        if (!r.colunaProduto) erros.push(`Regra ${i + 1}: selecione a coluna.`);
        if (!r.valor || !String(r.valor).trim()) erros.push(`Regra ${i + 1}: informe o valor.`);
      });

      (this.item.campos || []).forEach((c, i) => {
        if (!c.colunaProduto) erros.push(`Campo ${i + 1}: selecione a coluna.`);
      });

      const colunasRegras = (this.item.regras || [])
        .map((regra) => regra.colunaProduto)
        .filter(Boolean);
      if (colunasRegras.length !== new Set(colunasRegras).size) {
        erros.push("Cada coluna só pode ter uma regra.");
      }

      const colunasCampos = (this.item.campos || [])
        .map((campo) => campo.colunaProduto)
        .filter(Boolean);
      if (colunasCampos.length !== new Set(colunasCampos).size) {
        erros.push("Cada coluna só pode aparecer uma vez como campo.");
      }

      this.erros = erros;
      return erros.length === 0;
    },
    handleSubmit() {
      if (!this.validar()) return;

      const payload = {
        nome: this.item.nome,
        descricao: this.item.descricao || null,
        ativo: this.item.ativo ? 1 : 0,
        regras: this.item.regras,
        campos: this.item.campos,
      };

      if (this.item.id) {
        this.update(payload);
      } else {
        this.create(payload);
      }
    },
    create(payload) {
      this.loading = true;
      post("/admin/grupo-grade", payload)
        .then(() => {
          this.$swal({
            title: "Grupo criado!",
            icon: "success",
            timer: 1500,
            showConfirmButton: false,
          });
          this.close();
        })
        .catch((err) => {
          this.$swal({
            title: "Falha ao cadastrar",
            text: this.extrairMensagemErro(err),
            icon: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    update(payload) {
      this.loading = true;
      put(`/admin/grupo-grade/${this.item.id}`, payload)
        .then(() => {
          this.$swal({
            title: "Grupo atualizado!",
            icon: "success",
            timer: 1500,
            showConfirmButton: false,
          });
          this.close();
        })
        .catch((err) => {
          this.$swal({
            title: "Falha ao atualizar",
            text: this.extrairMensagemErro(err),
            icon: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    extrairMensagemErro(err) {
      if (err && err.errors && err.errors[0] && err.errors[0].detail) return err.errors[0].detail;
      if (err && err.message) return err.message;
      return "Verifique os dados e tente novamente.";
    },
  },
};
</script>

<style scoped>
.modal-title {
  font-size: 18px;
  font-weight: 600;
  color: #1d2939;
  margin: 0 0 16px;
}

.modal-footer-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  padding: 14px 20px;
  border-top: 1px solid #e9ecef;
  background: #fff;
}

.erros-alert {
  border-radius: 8px;
  font-size: 13px;
}
</style>

<style>
.modalbox.grupo-grade-modalbox .tab-pane {
  padding: 16px 0 !important;
}

.modalbox.grupo-grade-modalbox .nav-tabs-boxed .tab-content {
  max-height: none !important;
  overflow: visible !important;
}

.modalbox.grupo-grade-modalbox > .modalbox-content {
  max-height: none !important;
  overflow: visible !important;
}

/* Permite que dropdowns (multiselect) escapem da borda do modal sem serem
   cortados pelo overflow:hidden padrão do .v--modal-box da lib vue-js-modal. */
.v--modal-overlay:has(.grupo-grade-modalbox) .v--modal-box {
  overflow: visible !important;
}
</style>
